export default __webpack_public_path__ + "static/media/emailIcon.19789d70.svg";